/**
 * The product's name, two words, as every page, email, sender, title and
 * piece of structured data shows it. Site and email templates read it as
 * `{{brand}}` (src/main.ts, src/email/render.ts), the SPA's HTML as
 * `%BRAND_NAME%` (web/vite.config.ts).
 *
 * Only what users read: code identifiers (`rise-radar`, `raise_sonar_alerts`,
 * `WEEKLY_RADAR`) and the domains (raisesonar.com, app.raisesonar.com) keep
 * their own spelling. src/shared/brand.spec.ts fails on the old spellings.
 */
export const BRAND_NAME = 'Raise Sonar';

/**
 * `{{brand}}` in a Handlebars instance's templates, `(brand)` in a partial's
 * arguments. Every instance that draws a page or an email needs it: one
 * without it prints nothing there, and a strict one (the emails') throws.
 */
export function registerBrand(handlebars: {
  registerHelper(name: string, fn: () => string): void;
}): void {
  handlebars.registerHelper('brand', () => BRAND_NAME);
}
